import React, { useRef } from 'react';
import Search from 'components/search';
import withURLSync from 'URLSync';
import SearchContainer from "./index.style";
const SearchPage = props => {
  const containerRef = useRef(null);
  const headerRef = useRef(null);


  return (
    <SearchContainer>
      <Search />

    </SearchContainer>
  );
};

export default withURLSync(SearchPage);